import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import {
  AccountStatus,
  SkinningUser,
  ProfileHistoryResponse,
  VerificationStatus,
} from './types';

export interface SkinningUserFilters {
  userId?: string | null;
  externalReference?: string | null;
  loginCountry?: string | null;
  eidProviderType?: string | null;
  emailAddress?: string | null;
  name?: string | null;
  personalIdNumber?: string | null;
  createdAtLte?: string | null;
  createdAtGte?: string | null;
  riskScoreGte?: number | null;
  status?: string | null;
  sourceOfFundsVerificationStatus?: string | null;
  emailAddressVerificationStatus?: string | null;
}

export interface Pagination {
  page: number;
  size: number;
}

interface SearchAggregatedData {
  count: number;
}

export interface SearchResponse {
  profiles: SkinningUser[];
  aggregatedData: SearchAggregatedData;
}

export const searchSkinningUsers = async ({
  filters,
  pagination,
}: {
  filters: SkinningUserFilters;
  pagination: Pagination;
}) => {
  return fetchAPI<SearchResponse>('v1/skinning-users:search', {
    method: 'POST',
    body: {
      filters,
      pagination,
    },
  });
};

export const updateUser = ({
  userReference,
  riskScoreAdjustment,
  sourceOfFundsVerificationStatus,
  status,
}: {
  userReference: string;
  riskScoreAdjustment?: number | null;
  status?: AccountStatus;
  sourceOfFundsVerificationStatus?: VerificationStatus | null;
}) => {
  let body: any = {
    status,
  };
  if (riskScoreAdjustment != null) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    body = { ...body, riskScoreAdjustment };
  }
  if (sourceOfFundsVerificationStatus != null) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    body = { ...body, sourceOfFundsVerificationStatus };
  }
  return fetchAPI(`v1/skinning-users/${userReference}`, {
    method: 'PUT',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    body,
  });
};

export const getProfileHistory = async (userReference: string) => {
  const response = await fetchAPI<ProfileHistoryResponse>(
    `v1/skinning-users/${userReference}/history`
  );
  console.log(response);

  response.profileHistory.forEach((history) => {
    history.createdAt = new Date(history.createdAt);
  });
  response.kycHistory.forEach((history) => {
    history.createdAt = new Date(history.createdAt);
  });
  response.onboardingHistory.forEach((history) => {
    history.createdAt = new Date(history.createdAt);
  });

  return response;
};

export interface KycDocumentImage {
  fileName: string;
  fileUrl: string;
  issuingCountryCode?: string;
  savedAt: Date;
}

export interface KycDocumentImagesResponse {
  kycDocumentImages: string[];
}

export const getKycDocumentImages = async (userId: string) => {
  const response = await fetchAPI<KycDocumentImagesResponse>(
    `v1/skinning-users/${userId}/kyc-document-images`
  );

  return response.kycDocumentImages;
};
export const getKycDocumentImage = async (imageId: string) => {
  const response = await fetchAPI<KycDocumentImage>(
    `v1/skinning-users/kyc-document-image/${imageId}`
  );

  response.savedAt = new Date(response.savedAt);

  return response;
};

export const retriggerOnboarding = async (userReference: string) => {
  return fetchAPI(`v1/skinning-users/${userReference}/onboarding`, {
    method: 'DELETE',
  });
};
export interface SearchTransactionsResponse {
  transactions: any[];
}
export const searchTransactions = async ({
  filters,
}: {
  filters: { userId: string };
}) => {
  const response = await fetchAPI<SearchTransactionsResponse>(
    `v1/skinning-users/transactions:search`,
    {
      method: 'POST',
      body: {
        filters,
      },
    }
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return response.transactions;
};

export const getTransactionDetails = async (transactionId: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return await fetchAPI<any>(`v1/skinning-users/transactions/${transactionId}`);
};
